import { testConnection, createContact, getHubSpotConfig } from './lib/hubspotClient';

// Test HubSpot Integration
export const testHubSpotIntegration = async () => {
  console.log('🔄 Testing HubSpot Integration...');
  
  // Check configuration
  const config = getHubSpotConfig();
  console.log('📊 HubSpot Config:', {
    hasApiToken: !!config.apiToken && config.apiToken !== 'not configured',
    portalId: config.portalId,
    syncEnabled: config.syncEnabled
  });
  
  try {
    // Test connection
    console.log('🔗 Testing HubSpot connection...');
    const connectionResult = await testConnection();
    console.log('✅ Connection test result:', connectionResult);
    
    if (connectionResult.success) {
      // Test creating a contact
      console.log('👤 Testing contact creation...');
      const testContact = {
        email: `test-${Date.now()}@example.com`,
        firstname: 'Test',
        lastname: 'User',
        lifecycle_stage: 'subscriber' as const,
        og01_user_id: `test-${Date.now()}`,
        og01_plan_tier: 'Starter Pro' as const,
        og01_signup_source: 'Direct App' as const,
        og01_subscription_status: 'Trialing' as const
      };
      
      const contactResult = await createContact(testContact);
      console.log('✅ Contact creation result:', contactResult);
      
      return {
        success: true,
        connectionTest: connectionResult,
        contactTest: contactResult
      };
    } else {
      return {
        success: false,
        error: 'Connection test failed',
        connectionTest: connectionResult
      };
    }
  } catch (error) {
    console.error('❌ HubSpot integration test failed:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
};

// Export for console testing
if (typeof window !== 'undefined') {
  (window as unknown as { testHubSpot: typeof testHubSpotIntegration }).testHubSpot = testHubSpotIntegration;
} 